import React, { CSSProperties, useMemo, useState, createContext } from "react";
import { IframeContextType, IframeProviderProps } from "./types";

export const IframeContext = createContext<IframeContextType | undefined>(
  undefined
);

export const IframeProvider: React.FC<IframeProviderProps> = ({
  children,
  initialStyle = {},
  initialVisible = true,
}) => {
  const [src, setSrcState] = useState<string | null>(null);

  const [visible, setVisible] = useState<boolean>(initialVisible);
  const [style, setStyle] = useState<CSSProperties>(initialStyle);

  const setSrc = (value: string) => {
    setSrcState(value);
  };

  const contextValue = useMemo(
    () => ({
      src,
      setSrc,
      visible,
      setVisible,
      style,
      setStyle,
    }),
    [src, visible, style]
  );

  return (
    <IframeContext.Provider value={contextValue}>
      {children}
      {src && (
        <div
          style={{
            bottom: 0,
            display: visible ? "flex" : "none",
            height: "100%",
            left: 0,
            pointerEvents: "none",
            position: "absolute",
            right: 0,
            top: 0,
            width: "100%",
          }}
        >
          <iframe
            src={src}
            title="persistent-iframe"
            style={{
              pointerEvents: "all",
              ...style,
            }}
          />
        </div>
      )}
    </IframeContext.Provider>
  );
};
